import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { catchError, EMPTY, Observable, throwError } from "rxjs";
import { AlertsService } from "src/app/core/alerts.service";
import { ApiError } from "src/app/core/api-error";
import { environment } from "src/environments";
import { UserService } from "./core/auth/user.service";

@Injectable()
export class NetworkResponseErrorInterceptor implements HttpInterceptor {
  public constructor(
    private readonly user: UserService,
    private readonly alerts: AlertsService,
  ) {}

  public intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error) => {
        if (!(error instanceof HttpErrorResponse)) {
          return throwError(() => error);
        }

        const apiError = ApiError.create(error);

        if (apiError.status === 401) {
          // Logout whenever the request is to one of the authenticated APIs
          // that is provided an auth token from the UI via MSAL.

          if (request.url.startsWith(environment.apiUrls.yms.href)) {
            this.user.logout();
            return EMPTY;
          }

          return throwError(() => apiError);
        }

        // Skip the alert for "Not Found" errors so that an appropriate splash
        // page can be shown to the user as needed.
        if (apiError.status === 404) {
          return throwError(() => apiError);
        }

        if (
          (apiError.status === 400 || apiError.status === 500) &&
          request.method !== "GET"
        ) {
          this.alerts.error({
            title: "Failed to Save",
            message: apiError.message,
          });
        }

        // Only alert on GETs so that other methods can handle their own errors
        // as needed.
        if (request.method === "GET") {
          this.alerts.error({
            title: `Request Error (${apiError.status})`,
            message:
              "The page failed to load correctly. Please refresh to try again.",
            error,
          });
        }

        return throwError(() => apiError);
      }),
    );
  }
}
